<div class="container-fluid grey-bg form-wrapper thankyou-wrapper">
  <div class="row">
    <div class="col-12">
      <div class="form-box text-center">
        <div class="top-detail">
          <a href="/" title="Back to Home"><img alt="world of sweets logo" src="../../assets/images/bonds-logo-footer.svg" /></a>
        </div>
        <img src="/assets/images/success-password.svg"/>
        <h2>Success!</h2>
        <p class="max-340">
          Check your email account for further instructions on how to reset your password.
        <p>
          <button routerLink="/users/login"  type="submit" class="btn primary-btn">Go Back To Home</button>
      </div>
      <app-footer></app-footer>
    </div>
  </div>
</div>